import { Internal_CheckPermissions } from "@swivl-mono/helpers";
import { APIScope } from "@swivl-mono/types";

import AccountModel from "../../Models/Account/AccountModel";
import RolesModel from "../../Models/Roles/Roles.Model";

export function HasPermission(action: APIScope, orgId: number, groupId?: number, locationId?: number): boolean {
  const { defaultRoles, parentRoles, roles } = RolesModel.state;
  const member = AccountModel.state.member;
  if (!member || !roles) {
    return false;
  }
  // Merge defaultRoles into the parent map so parentSlug lookups for "admin"/"agent"/"manager" resolve.
  const mergedParents = { ...(defaultRoles ?? {}), ...(parentRoles ?? {}) };
  return Internal_CheckPermissions(mergedParents, roles, member.permissions, action, member.orgId, groupId, locationId);
}
